<template>
  <div class="bulk-call-details">
    <div class="m-b-10 f-s-16">
      <i18n path="CALLS_SELECTED">
        <template v-slot:numberOfCalls>
          {{ selectedCalls.length }}
        </template>
      </i18n>
    </div>

    <table
      class="table_beauty bulk-call-details__table"
    >
      <thead>
        <tr class="bg-widget">
          <th v-t="'CAMPAIGN'" />
          <th v-t="'PUBLISHER'" />
          <th v-t="'CALLER_ID'" />
          <th v-t="'DIALED_NUMBER'" />
          <th v-t="'REVENUE'" />
          <th v-t="'PAYOUT'" />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in selectedCalls"
          :key="row.id"
          class="bg-transparent"
        >
          <td>
            {{ row.campaignName }}
          </td>
          <td>
            {{ row.publisherName }}
          </td>
          <td>
            {{ row.inboundPhoneNumber }}
          </td>
          <td>
            {{ row.number }}
          </td>
          <td>
            <p v-if="row.conversionAmount">
              {{ row.conversionAmount | currency }}
            </p>
          </td>
          <td>
            <p v-if="row.payoutAmount">
              {{ row.payoutAmount | currency }}
            </p>
          </td>
          <td>
            <a
              class="btn btn-list-function"
              @click="removeCall(row)"
            >
              <i
                v-tooltip.right.hover="{text:$t('REMOVE_SELECTED_CALL'), transition: 0}"
                class="typcn typcn-delete-outline"
                aria-hidden="true"
              />
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import messages from './locales';
import sharedMessages from '@/core/locales';
import { currencyFormatter } from '../../AgGridUtils';

export default {
  name: 'BulkCallDetails',

  filters: {
    currency(value) {
      return currencyFormatter.format(value);
    }
  },
  props: {
    selectedCalls: {
      type: Array,
      default() {
        return [];
      }
    },
  },

  i18n: {
    messages,
    sharedMessages
  },
  methods: {
    removeCall(call) {
      this.$emit('unselectCallOnBulkAction', call);
    }
  }
};
</script>

<style lang="scss" scoped>
.bulk-call-details {
  display: inline-block;
}

.bulk-call-details__table {
  background: var(--component-bulk-call-details__table-bg);
}
</style>